import { render, staticRenderFns } from "./ui-loading.vue?vue&type=template&id=14b06d82"
import script from "./ui-loading.vue?vue&type=script&lang=js"
export * from "./ui-loading.vue?vue&type=script&lang=js"
import style0 from "./ui-loading.vue?vue&type=style&index=0&id=14b06d82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports